
  import { css } from 'lit';
  export const styles = css`[part="base focused"] ::slotted(div)::after{border:none;inset-block-start:.1875rem;inset-inline-start:.1875rem;width:calc(100% - 0.1875rem*2);height:calc(100% - 0.1875rem*2);box-shadow:0 0 0 .0625rem var(--button-focus-border-color);border-radius:0}`;
  